import type { Styles } from '@adornis/ass/style.js';
import { ExtensionBoilerplate } from '@adornis/buildify/client/extensions/ContentExtensionBoilerplate.js';
import { ThrowEventMoveToAnchor } from '@adornis/buildify/client/globals/events.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import type { DubniumBaseButton } from '../../../../../db/buildify/DubniumBaseButton.js';
import '../../../d-button.js';

@customElement('campus-button-extension')
export class CampusButtonExtension extends ExtensionBoilerplate<DubniumBaseButton> {
  protected override _content(content: DubniumBaseButton) {
    return html`
      <d-button
        mode=${content.invert ? 'outline' : 'action'}
        tone=${content.isDigitalEmergency ? 'emergency' : ''}
        ?invert=${content.invert}
        @click=${() => {
          const link = content.link;
          if (!link) return;
          if (link.link?.startsWith('#')) {
            // * anchor logic
            const anchor = link.link.substring(1, link.link.length);
            return ThrowEventMoveToAnchor(this, anchor);
          }
          if (!link.resolvedLink) return;
          if (this.isEditMode) return;
          goTo(link.resolvedLink, { target: link.target || '_self' });
        }}
      >
        ${content.text}
      </d-button>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        'd-button': {
          position: 'relative',
          display: 'block',
          width: 'max-content',
          ...(() => {
            switch (this.getValue('alignHorizontal')) {
              case 'start':
                return { marginRight: 'auto' };
              case 'center':
                return { left: '50%', transform: 'translateX(-50%)' };
              case 'end':
                return { marginLeft: 'auto' };
            }
          })(),
        },
      },
    ] as Styles[];
  }
}
